// src/components/DistributionBar.jsx
//
// Horizontal proportion bars for the doctor portal (the Dashboard). A bar
// chart rather than a donut because these are parts of a whole read against each
// other, and the counts matter as much as the proportions — both are labelled.
// rows: [{ label, count, color }] where color is a CSS var such as 'var(--red)'.

import React from 'react';

export default function DistributionBar({ rows, total, emptyText = 'Nothing to show yet.' }) {
  if (total === 0) {
    return (
      <div className="empty-state" style={{ padding: '20px 0' }}>
        <div className="empty-desc">{emptyText}</div>
      </div>
    );
  }
  return (
    <div className="meter-list">
      {rows.map(row => {
        const pct = Math.round((row.count / total) * 100);
        return (
          <div key={row.label}>
            <div className="meter-head">
              <span>{row.label}</span>
              <span className="meter-value">
                {row.count} <span className="meter-pct">({pct}%)</span>
              </span>
            </div>
            <div className="meter-track">
              <div
                className="meter-fill"
                style={{ width: `${pct}%`, background: row.color }}
                role="img"
                aria-label={`${row.label}: ${row.count} of ${total}, ${pct} percent`}
              />
            </div>
          </div>
        );
      })}
    </div>
  );
}
